function toDisplayText(value) {
	return String(value ?? '').trim();
}

function pickFirstDisplayValue(values) {
	for (const value of values) {
		const text = toDisplayText(value);
		if (text) {
			return text;
		}
	}
	return '';
}

export function resolvePrivateDisplayName(friend) {
	return pickFirstDisplayValue([
		friend && friend.remarkNickName,
		friend && friend.showNickName,
		friend && friend.nickName,
		friend && friend.userName
	]);
}

export function resolveGroupMemberDisplayName(member, friend = null, user = null) {
	return pickFirstDisplayValue([
		friend && friend.remarkNickName,
		member && member.remarkNickName,
		member && member.showNickName,
		user && user.nickName,
		friend && friend.showNickName,
		friend && friend.nickName,
		friend && friend.userName
	]);
}

export function resolveGroupChatDisplayName(group) {
	return pickFirstDisplayValue([
		group && group.showGroupName,
		group && group.remarkGroupName,
		group && group.name
	]);
}
